<script lang="ts">
  import { goto, params } from '@roxi/routify';

  let slug: string = $params.slug;

  $goto('/jobs/' + slug); //Redirect the user automatically to the "job" part when clicking on a branch
</script>
